<template>
  <learner-homepage-content />
</template>

<script>
import LearnerHomepageContent from './learner-homepage-content.vue';

export default {
  components: {
    LearnerHomepageContent,
  },
};
</script>
